enum SignUpStep {
  zero = 0,
  one = 1,
  two = 2,
}

export default SignUpStep;
